import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getDepositAccountsPath = () => urlHelper('/deposit-accounts');
